import { Select, Typography } from "antd";
import { FormOutlined } from "@ant-design/icons";
import { Flex } from "../../../../../common/components/flex/flex";

const { Text } = Typography;

const Label = ({ isWorkflowModified, children }) => (
  <Flex align="center" gap={8}>
    {isWorkflowModified && <FormOutlined className="text-primary" />}

    <Text ellipsis title={children}>
      {children}
    </Text>
  </Flex>
);

export const ClientSelector = ({ clients, value, onChange, disabled }) => {
  const clientOptions = clients.map((c) => ({
    value: c.id,
    label: <Label isWorkflowModified={c.isWorkflowModified}>{c.name}</Label>,
    searchLabel: c.name,
  }));

  return (
    <Select
      id="client-select"
      placeholder="Select Client"
      options={clientOptions}
      onChange={onChange}
      value={value}
      showSearch
      disabled={disabled}
      filterOption={(input, option) =>
        option.searchLabel.toLowerCase().includes(input.toLowerCase())
      }
      style={{ width: "100%" }}
    />
  );
};
